import log2 from "../log2";

const log = log2("SpeechToTextService");
export default class SpeechToTextService extends EventTarget {
    constructor(continuous = false) {
        super();
        this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.enabled = !!this.SpeechRecognition;
        this.continuous = continuous;
        this.text = "";
        this.initialize();
    }

    emit(type, payload) {
        this.dispatchEvent(new CustomEvent(type, { detail: payload }));
    }

    initialize() {
        if (!this.enabled) return;
        this.recognition = new this.SpeechRecognition();
        this.recognition.continuous = this.continuous;
        this.recognition.interimResults = true;
        this.recognition.lang = "tr-TR";
        this.recognition.maxAlternatives = 1;
        this.recognition.start();
        this.recognition.onerror = (event) => {
            log.error("recognition  error", event);
            this.recognitionStopReason = "error";
            this.emit("error", event);
            this.emit("end", this.text);
        };
        this.recognition.onend = (event) => {
            log("recognition end", event);
            this.emit("end", this.text);
        };
        this.recognition.onresult = (event) => {
            log("recognition result", event);
            const { results, resultIndex } = event;
            const isFinal = results[resultIndex].isFinal;
            const current = results[resultIndex][0];
            this.text = current.transcript;
            if (isFinal) {
                this.emit("end", this.text);
            } else {
                this.emit("text", this.text);
            }
        };
    }

    stop() {
        if (this.recognition) this.recognition.stop();
    }
}
